import { Filter, FilterOption } from '@/types/product-filter';
import { priceIntervalLowBound, sortPriceFilterOptions } from '@/utils/price-interval-sort-key';

/** Stable sort for facet filter options (shared by build-time filter creation and UI). */
export const sortFilterOptions = (filterId: string, options: FilterOption[]): FilterOption[] => {
  if (filterId === 'price') {
    return sortPriceFilterOptions(options);
  }

  const intervalLows = options.map(o => priceIntervalLowBound(o.value));
  const allNumericIntervals = options.length > 0 && intervalLows.every(low => low !== undefined);

  if (allNumericIntervals) {
    return options.toSorted(
      (a, b) => priceIntervalLowBound(a.value)! - priceIntervalLowBound(b.value)!,
    );
  }

  const isAllNumber = options.every(option => Number.isInteger(Number(option.value)));

  if (isAllNumber) {
    return options.toSorted((a, b) => Number(a.value) - Number(b.value));
  }

  return options.toSorted((a, b) => a.label.localeCompare(b.label));
};

/** Returns a filter copy with options sorted for display. */
export const withSortedFilterOptions = (filter: Filter): Filter => ({
  ...filter,
  options: sortFilterOptions(filter.id, filter.options),
});

export const getFilterOptionsListKey = (filterId: string, options: FilterOption[]) =>
  `${filterId}-${options.map(o => o.value).join('|')}`;
